import React from 'react';
import { useAlert } from "react-alert";
import '../../dash.css'
import '../../key.css'

const CardActivate = () => {

    const alert = useAlert();
    var valid = false

    function alertError(message){
        if (document.getElementById('__react-alert__').children.length === 0) {
            alert.error(message)
        }
    }

    function ButtonSubmit(e){
        var input = document.getElementsByClassName('input')[0].value;
        input_validator(input)
    }

    function handleOnFocus(e){
        if(e.target.value==='License key') e.target.value='';
    }

    function handleBlur(e){
        if(e.target.value.replace(/ /g,'')==='') e.target.value=''
    }

    function input_validator(e){
        if (e.length === 37){
            if(e.substring(0,7).toUpperCase() === "INFINIT") valid = true;
            else valid = false
        }
        else valid = false

        if(valid){
            const key = e.toUpperCase();
            validate_key(key)
        }
        else{
            if(e.replace(/ /g,'').length < 1){
                alertError("Please enter a key")
            }
            else{
                alertError("Bad format")
            }   
        }
    }

    async function validate_key(key) {
        if(document.getElementsByClassName('activate')[0].disabled === false){
            document.getElementsByClassName('activate')[0].disabled = true;
            const url = `${process.env.REACT_APP_API_URL}/claim-key/`
            const form = new FormData()
            form.append('key', key)

            fetch(url, {
                credentials: "include",
                method: 'POST',
                body: form
                })
                .then(function (response) {
                    if(response.status === 200){

                        if (document.getElementById('__react-alert__').children.length === 0) {
                            alert.success("Valid key")
                        }
                        setTimeout(() => { window.location.reload(false) }, 2000);    
                    }
                    else{
                        if(response.status < 500){
                            response.json().then(function(data){
                                if(data.message === 'Key does not exist'){
                                    alertError("Invalid key")
                                }
                                else{
                                    alertError("Unable to activate")
                                }
                            })
                        }
                        else{
                            alertError("Unable to activate")
                        }
                        document.getElementsByClassName('activate')[0].disabled = false;
                    }
                })
                .catch(err => {
                    alertError("Unable to activate")
                    document.getElementsByClassName('activate')[0].disabled = false;
                    console.log(err)
                });
        }
    }

    return(
        <div className="activate-card">
            <div className="infinit item rotate">
                <img src="https://i.ibb.co/524TY6N/infinit-logo.png" alt="" className="infinit-logo slide-right"></img>
            </div>
            <div className="item activator">
                <div className="input-holder">
                    <i className="fas fa-unlock"></i>
                    <input type="text" className="input" placeholder="License key" maxLength={37} autoComplete="off" onFocus={handleOnFocus} onBlur={handleBlur}></input>
                </div>
                <div>
                    <button id="submit-key" type="submit" className="activate" onClick={ButtonSubmit}>Activate</button>
                </div>
            </div>
            <div className="disclaimer item">
                <i className="fas fa-exclamation-circle"></i><h6 className="no-margin license-warning">The license provided will be bound to this Discord account.</h6>
            </div>
        </div>
    )
};

export default CardActivate;